import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { FaPlus } from "react-icons/fa";
import CreateRosterPlayerForm from "../../pages/rosters/CreatePlayer";

export default function DashRosters() {
  const { user } = useSelector((state) => state.user);
  const [rosters, setRosters] = useState([]);
  const [displayedRosters, setDisplayedRosters] = useState(10);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedRosterId, setSelectedRosterId] = useState(null);

  const handleShowMore = () => {
    setDisplayedRosters((prevDisplayed) => prevDisplayed + 1);
  };

  const openModal = (rosterId) => {
    setIsModalOpen(true);
    setSelectedRosterId(rosterId);
  };

  const closeModal = () => {
    setIsModalOpen(false);
  };

  useEffect(() => {
    const fetchRosters = async () => {
      try {
        const response = await fetch(
          `https://server-postgre.vercel.app/get-rosters`,
          {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
            },
            body: JSON.stringify({ user_id: user.id }),
          }
        );
        const rostersData = await response.json();

        // Fetch players data for each roster
        const rostersWithPlayers = await Promise.all(
          rostersData.map(async (roster) => {
            const playersResponse = await fetch(
              `https://server-postgre.vercel.app/get-players`,
              {
                method: "POST",
                headers: {
                  "Content-Type": "application/json",
                },
                body: JSON.stringify({ roster_id: roster.id }),
              }
            );
            const playersData = await playersResponse.json();
            return { ...roster, players: playersData };
          })
        );

        setRosters(rostersWithPlayers);
      } catch (error) {
        console.error("Error fetching rosters:", error);
      }
    };

    fetchRosters();
  }, [user.id]);

  return (
    <div>
      {isModalOpen && (
        <div className="fixed top-0 left-0 w-full h-full flex items-center justify-center bg-black bg-opacity-50 z-50">
          <CreateRosterPlayerForm
            closeModal={closeModal}
            rosterId={selectedRosterId}
          />
        </div>
      )}
      {rosters.slice(0, displayedRosters).map((roster) => (
        <div key={roster.id} className=" mt-3 border rounded-lg p-2 ml-2">
          <div
            className="block mx-2 text-center bg-gradient-to-b from-amber-200 to-blue-300 rounded-lg p-8"
            style={{ height: "90px" }}
          >
            <h2>
              {roster.team_name} - {roster.clasification}
            </h2>
            {/* <a href={`/rosters/${roster.id}`}></a> */}
          </div>
          <div className="flex flex-wrap">
            {roster.players &&
              roster.players.map((player, index) => (
                <div
                  key={index}
                  className="text-center border rounded-lg p-2 m-2"
                  style={{ width: "160px" }} // Ancho máximo de 50% menos el espacio de los márgenes
                >
                  <img
                    className="h-24 rounded-full mx-auto"
                    src={`https://server-postgre.vercel.app/${player.photo_url}`}
                    alt={`${player.first_name} ${player.last_name}`}
                  />
                  <p className="mt-2">
                    {player.first_name} {player.last_name}
                  </p>
                </div>
              ))}
            <button
              onClick={() => openModal(roster.id)}
              className="font-semibold py-2 px-4 rounded-lg shadow-md transition duration-300 ease-in-out transform hover:scale-105"
            >
              <FaPlus className="mr-1" />
              Agregar jugador
            </button>
          </div>
        </div>
      ))}

      {rosters.length > displayedRosters && (
        <button
          onClick={handleShowMore}
          className="bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded mt-2"
        >
          Show 1 more
        </button>
      )}
    </div>
  );
}
